import axios from 'axios';
import { ISsoClaims } from '../models/Login/ISsoClaims';

function loginService() {
  const instance = axios.create({
    baseURL: '/',
    timeout: 120000,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: '*/*',
    },
    withCredentials: false,
  });

  function getSsoClaims(): ISsoClaims {
    const ssoClaims: ISsoClaims = {
      id_token: '',
      session_state: '',
      scope: '',
      profile: null,
    };
    return ssoClaims;
  }

  function login<ILoginResponse>() {
    return instance.post('api/token');
  }
  return {
    getSsoClaims,
    login,
  };
}

export default loginService;
